export default function CharterCTA() {
  const scrollToSearch = () => {
    const searchSection = document.getElementById('charter-search');
    if (searchSection) {
      searchSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  const scrollToContact = () => {
    window.REACT_APP_NAVIGATE('/');
    setTimeout(() => {
      const contactSection = document.getElementById('contact');
      if (contactSection) {
        contactSection.scrollIntoView({ behavior: 'smooth' });
      }
    }, 100);
  };

  return (
    <section className="relative py-32 px-8 lg:px-16">
      <div 
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url('https://static.readdy.ai/image/af0cbc08a3b78af074c92730eb798524/24f68e49e12c9bbb14e9671140717628.jpeg')`
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
      </div>
      
      <div className="relative z-10 max-w-4xl mx-auto text-center">
        <div className="w-20 h-px bg-white mx-auto mb-8"></div>
        <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl text-white mb-8">
          Begin Your Charter
        </h2>
        <p className="text-lg md:text-xl text-white/90 leading-relaxed mb-12 max-w-2xl mx-auto">
          Browse available yachts, submit a charter inquiry, or speak directly with a charter advisor to plan your perfect voyage.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <button 
            onClick={scrollToSearch}
            className="px-10 py-4 bg-white text-black text-sm tracking-widest hover:bg-gray-100 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            BROWSE AVAILABLE YACHTS
          </button>
          <button 
            onClick={scrollToContact}
            className="px-10 py-4 bg-transparent border-2 border-white text-white text-sm tracking-widest hover:bg-white hover:text-black transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            SPEAK WITH A CHARTER ADVISOR
          </button>
        </div>
      </div>
    </section>
  );
}
